export default __webpack_public_path__ + "static/media/mycv.b23c77e2.pdf";